import React from "react";
import BaseDialog from "./BaseDialog";

interface HelpModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const HelpModal: React.FC<HelpModalProps> = ({ isOpen, onClose }) => {
    // Removed useSWR — not needed when loading a static URL
    const helpUrl = "https://ifu.medibyt.com?v=1";

    return (
        <BaseDialog
            isOpen={isOpen}
            onClose={onClose}
            classes={{
                // aspect ratio like a4 paper
                dialogPanel: "max-h-none aspect-[1.414/1] px-0 py-0",
            }}
        >
            <iframe
                src={helpUrl}
                title="Help Content"
                className="w-full h-full border-0"
            />
        </BaseDialog>
    );
};

export default HelpModal;
